module.exports = __webpack_public_path__ + "img/uploadVodeo.6cf3bf25.png";